<!-- 乐读快应用注册 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">染色时间</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">用户ID</div>
				<a-input v-model="r_userId" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>

			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_push_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否加桌</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeTGPT"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in tgptSelect" :key="key" :value="key">{{value}}</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广计划ID</div>
				<a-input v-model="r_plan_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广创意ID</div>
				<a-input v-model="r_creativeid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量项目ID</div>
				<a-input v-model="r_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量广告ID</div>
				<a-input v-model="r_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeC" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'userAgent' && z_tem.type != 'is_add_desktop' && z_tem.type != 'is_match_ad'"
				class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- UA -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'userAgent'"  class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					<a-popover v-if="item.userAgent" placement="top">
						<template slot="content">
						  <p style="width: 430px;word-break: break-word;">{{item.userAgent}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item.userAgent}}
						</div>
					</a-popover>
				</div>
				<!-- 是否加桌 -->
				<div  v-else-if="z_ndex > sticky_index && z_tem.type == 'is_add_desktop'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.add_desktop_time ? '是' : '否'}}
				</div>
				<!-- 是否匹配 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'is_match_ad'"  class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.is_match_ad == 1 ? '是' : '否'}}
				</div>
			</template>
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, regLdList,  orderGzhCustomReport, regGzhReport, qkChannelMedia } from '@/request/api'
export default {
	name: 'registerLd_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"染色时间", width:150, type:"register_time", },
				
				{title:"用户Id", width:100, type:"userId", },
				{title:"推广链接ID", width:100, type:"userLinkId", },
				{title:"推广作品", width:160, type:"book_name", },
				{title:"IP", width:150, type:"ip", },
				{title:"UA", width:180, type:"userAgent", },
				{title:"用户手机厂商", width:120, type:"manufacturer", },
				
				{title:"是否加桌", width:100, type:"is_add_desktop", },
				{title:"加桌时间", width:150, type:"add_desktop_time", },
				
				{title:"是否匹配", width:110, type:"is_match_ad", },
				{title:"推广平台", width:110, type:"channel_name", },
				
				{title:"推广计划ID", width:150, type:"adid", },
				{title:"推广创意ID", width:150, type:"creativeid", },
				{title:"巨量2.0项目ID", width:160, type:"marketing_project_id", },
				{title:"巨量2.0广告ID", width:160, type:"marketing_promotion_id", },

				{title:"是否回传", width:130, type:"is_report_active", },
				{title:"回传原因", width:120, type:"not_report_active_reason", },
				{title:"回传时间", width:120, type:"report_active_time", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			sticky_index: 1,
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_userId: null, // 乐读用户ID
			r_plan_id: null, // 计划ID
			r_is_report_active: undefined, // 是否回传激活。1为是。0为否
			r_is_add_desktop: undefined, // 是否加桌。1为是。0为否
			r_is_match_ad: undefined, // 是否匹配点击。1为是。0为否
			r_push_link_id: null, // 推广链接ID

			r_ip: null, // IP
			r_channel_id: undefined, // 推广平台
			r_creativeid: null, // 创意ID
			r_project_id: null, // 巨量项目ID
			r_promotion_id: null, // 巨量广告ID
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			tgptSelect: {},
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()
		
		// 推广平台/媒体平台下拉
		qkChannelMedia().then(res=>{
			console.log("推广平台/媒体平台下拉",res);
			that.tgptSelect = res.data.data.list
		})
		
		// 搜索
		that.searchButton()

	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},

		handleChangeC(e){ // 是否回传激活
			console.log(e);
			this.r_is_report_active = e
			
		},
		handleChangeD(e){ // 是否加桌
			console.log(e);
			this.r_is_add_desktop = e
		},
		handleChangeE(e){ // 是否匹配点击
			console.log(e);
			this.r_is_match_ad = e
		},
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		handleChangeTGPT(e){ // 推广平台
			this.r_channel_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			regLdList({
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),

				userId: that.r_userId, // 乐读用户ID
				plan_id: that.r_plan_id, // 计划ID
				is_report_active: that.r_is_report_active, // 是否回传激活。1为是。0为否
				is_add_desktop: that.r_is_add_desktop, // 是否加桌。1为是。0为否
				is_match_ad: that.r_is_match_ad, // 是否匹配到计划
				push_link_id : that.r_push_link_id, // 推广链接ID
				
				ip: that.r_ip,
				channel_id: that.r_channel_id, // 推广平台
				creativeid: that.r_creativeid, // 创意ID
				project_id: that.r_project_id, // 巨量项目ID
				promotion_id: that.r_promotion_id, // 巨量广告ID
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			regGzhReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
	},
	
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>